import { ProgressBar, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

export enum EInfoLabelLocation {
  TOP = 'top',
  TOOLTIP = 'tooltip',
}

export interface IBudgetProgressBarProps {
  currentAmount: number
  totalAmount: number
  title?: string
  infoLabel?: string
  infoLabelLocation: EInfoLabelLocation
}

export const BudgetProgressBar: React.FC<IBudgetProgressBarProps> = ({
  currentAmount,
  totalAmount,
  title,
  infoLabel,
  infoLabelLocation = EInfoLabelLocation.TOOLTIP,
}) => {
  const [toggle, setToggle] = useToggle(false)
  const percentage = Math.round((currentAmount * 100) / totalAmount)

  const progressColorBar = () => {
    if (percentage >= 75 && percentage < 100) return 'champagne1000'
    if (percentage >= 100) return 'radicalRed1000'
    return 'viridian1000'
  }
  const colorBar = () => {
    if (percentage >= 75 && percentage < 100) return 'champagne100'
    return 'viridian100'
  }

  const isTooltipInfo = infoLabel && infoLabelLocation === EInfoLabelLocation.TOOLTIP

  return (
    <>
      {title && <Text.Normal>{title}</Text.Normal>}
      {infoLabelLocation === EInfoLabelLocation.TOP && (
        <Text.Header2 weight="semibold">{infoLabel}</Text.Header2>
      )}
      <Tooltip.Dialog
        open={isTooltipInfo ? toggle : false}
        toggle={setToggle}
        attachment="top center"
        label={infoLabel}
        size="small"
      >
        <ProgressBar
          percentage={percentage}
          amount={currentAmount}
          total={totalAmount}
          barColor={colorBar()}
          progressColor={progressColorBar()}
        />
      </Tooltip.Dialog>
    </>
  )
}
